import {IRouteGroupStructure} from '@shared/common/routing/IRouteStructure';

export class PublicRoutes {
  public static PREFIX = '';

  public static ACCOUNT = {
    PREFIX: 'account',
    login: {
      localPath: 'login',
      fullUrl: `${PublicRoutes.PREFIX}/account/login`,
      localeKey: 'Login',
    },
    forgotPassword: {
      localPath: 'forgot/password',
      fullUrl: `${PublicRoutes.PREFIX}/account/forgot/password`,
      localeKey: 'ForgotPassword',
    },
    resetPassword: {
      localPath: 'reset/password',
      fullUrl: `${PublicRoutes.PREFIX}/account/reset/password`,
      localeKey: 'ResetPassword',
    },
    signUp: {
      localPath: 'signup',
      fullUrl: `${PublicRoutes.PREFIX}/account/signup`,
      localeKey: 'SignUp',
    },
  };
}
